import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HcmShellHeaderComponent } from './common/header/hcm-shell-header/hcm-shell-header.component';
import { AppComponent } from './app.component';
import { LoggerService } from './logger.service';
import { CustomErrorHandler } from './errorhandler.provider';
import { MsalModule, MsalInterceptor, MsalGuard, MsalService } from '@azure/msal-angular';
import { PublicClientApplication, InteractionType } from '@azure/msal-browser';
import { RouterModule, Routes } from '@angular/router';
import { HcmShellHomeComponent } from './home/hcm-shell-home/hcm-shell-home.component';

const routes: Routes = [
    // { path: 'home', component: AppComponent,canActivate: [MsalGuard] },
    // { path: '', component: AppComponent, canActivate: [MsalGuard] }, 
    { path: 'home', component: HcmShellHomeComponent },
    // { path: '', component: AppComponent}, 
  ];

@NgModule({
  declarations: [
    AppComponent,
    HcmShellHeaderComponent
  ],

  imports: [
    BrowserModule,
    RouterModule.forRoot(routes),
    MsalModule.forRoot(new PublicClientApplication({
      auth: {
        clientId: '8f4c6f77-a378-4939-8557-c40a9ebe15ef',
        authority: 'https://login.microsoftonline.com/9107b728-2166-4e5d-8d13-d1ffdf0351ef',
        redirectUri: 'http://localhost:4200'
      }
    }), {
      interactionType: InteractionType.Redirect,
      authRequest: {
        scopes: ['user.read']
      }
    }, {
      interactionType: InteractionType.Redirect,
      protectedResourceMap: new Map([
        ['https://graph.microsoft.com/v1.0/me', ['user.read']]
      ])
    })

  ],
  providers: [LoggerService, { provide: ErrorHandler, useClass: CustomErrorHandler },
    MsalService, MsalGuard, MsalInterceptor,
		provideHttpClient(withInterceptorsFromDi())
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
